import config from "appConfig";
import { Slide } from "@jelly/lesson";

const principle: Slide = {
  layout: {
    type: "table",
    options: {
      cols: 2,
      rows: 2,
      colSpan: {
        "0:0": 2,
      },
      colsSize: [1, 3],
      rowsSize: [1, 9],
      gap: "20px",
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "Room acoustics measurement and simulation of an existing space\n",
                  styles: {
                    fontSize: "16px",
                    fontWeight: "700",
                  },
                  scrollbars: false,
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data:
                    `In this example, the chamber music hall of the Konzerthaus Berlin is presented.` +
                    `<br /><br />` +
                    `For this concert venue, in a first step, a room acoustic measurement of this space is conducted (according to the ISO 3382 standard) to obtain room impulse responses and room acoustic parameters for different sound source and receiver positions.` +
                    `<br /><br />` +
                    `In a second step, a corresponding simulation is prepared: The room model is created and the acoustical properties of the surfaces are defined.` +
                    `<br /><br />` +
                    `The results of the measurement and this first simulation are then compared and differences are discussed. In the next step, the simulation’s input data is adjusted in order to match the results of the measurements. Finally, the effect of the audience is investigated. The results are presented as parameters, but also as auralizations`,
                  styles: {
                    fontSize: "12px",
                    fontWeight: "600",
                  },
                  scrollbars: true,
                },
              },
            },
          },
          {
            variant: "layout",
            data: {
              type: "simple",
              options: {
                components: [
                  {
                    variant: "layout",
                    data: {
                      type: "table",
                      options: {
                        cols: 1,
                        rows: 2,
                        rowsSize: [8, 1],
                        gap: "15px",
                        components: [
                          [
                            {
                              variant: "blockContainer",
                              data: {
                                styles: {
                                  alignItems: "flex-end",
                                },
                                block: {
                                  type: "image",
                                  options: {
                                    src: `${config.ASSETS_URL}/03/case-01/principle/1-main.png`,
                                  },
                                },
                              },
                            },
                          ],
                          [
                            {
                              variant: "blockContainer",
                              data: {
                                styles: {
                                  alignItems: "flex-start",
                                },
                                block: {
                                  type: "text",
                                  options: {
                                    data:
                                      "Balcony shot of the chamber music hall of the Konzerthaus in Berlin with 250 seats in the parquet and 104 seats in the gallery.",
                                    styles: {
                                      textAlign: "center",
                                      fontSize: "10px",
                                      fontWeight: 600,
                                    },
                                  },
                                },
                              },
                            },
                          ],
                        ],
                      },
                    },
                  },
                ],
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
